import { ActivatedRoute, Router } from '@angular/router'
import { Injectable } from '@angular/core'
import { BlockDataService } from '../block-services/block-data.service'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { from, Observable, of } from 'rxjs'
import { HelpersService } from '../helpers.service'
import { ViewsService } from '../views/views.service'
import { StorageApiService } from './api/storage.api.service'
import imageCompression from 'browser-image-compression'
import { PagesApiService } from 'src/app/builder-services/api/pages.api.service'
import { ProjectApiService } from 'src/app/builder-services/api/project.api.service'
import { SettingsApiService } from 'src/app/builder-services/api/settings.api.service'
import { ViewsApiService } from 'src/app/builder-services/api/views.api.service'
import { Location } from '@angular/common'

@Injectable({
  providedIn: 'root'
})
export class BuilderService extends BlockDataService {
  public builderUrl: string

  projects: any = []
  selectedProject: any = 0
  headerBtn = ''
  starRating: any = 0
  tourStart: any
  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }
  token: any
  showUpdateProgress = false
  showSettingsProgress = false
  selectedProjectDomain: any = ''
  protectedImages: string[] = []
  globals = false
  globalHeader: any = {}
  globalFooter: any = {}
  globalMenus: any = {}
  globalSettings: any = {}
  projectsLimit = 0
  projectsPremiumCount = 0
  isOrderManager: boolean = false
  isProductManager: boolean = false
  isStockManager: boolean = false
  selectedIcon = ''
  currentProjectType = ''
  projectStatus = 'active'
  projectAccess = 'full'
  projectStartDate: any
  appOpenedCount = 0
  mobile_webview_link = ''
  customViews: any = []
  websitePages: any[] = []
  allViews: any = []
  cacheProjectReq: any = {
    response: '',
    data: ''
  }
  /** True when the project's effective plan (legacy project or account) is not free. Set by loadProjectPlan. */
  is_premium = false
  premium_status = ''
  stripe_subscription_id = ''
  premium_start_date = ''
  active_subscription_plan: any
  subscription_package: any
  invoices: any
  user_type = ''
  redirect_to = ''
  toggleSidebar = false
  blocksCollapsed = true
  loadingTemplates = false
  selected_coupon_id: any = ''
  selected_pricing_id: any = ''
  isListShown = true
  trialEnded = false
  previewStarted = false
  onboardingHomeStarted = false
  onboardingBlockAdded = false
  customerProfile: any = {}
  previewUrl = ''
  showBillingProgress = false
  restrictedPages: any = []
  // `addon` is the addon name used by AddonsAccessService (stacks_products.name)
  addons_pages_map: any = [
    {
      id: '1',
      name: 'Points & Rewards',
      addon: 'Points and Rewards',
      routes: ['/points', '/points/:id']
    },
    {
      id: '2',
      name: 'Coupons',
      addon: 'Coupon Management System',
      routes: ['/coupons', '/coupons/add-coupon', '/coupons/add-coupon/:id']
    },
    {
      id: '3',
      name: 'Multilingual',
      addon: 'Multilingual',
      routes: ['/multilingual', '/txtTranslations']
    },
    {
      id: '5',
      name: 'Discounts',
      addon: 'Timer and Flash Sale',
      routes: ['/discount', '/discount/add-discount', '/discount/add-discount/:id']
    },
    {
      id: '6',
      name: 'Wishlist',
      addon: 'Wishlist',
      routes: ['/wishlist']
    }
  ]
  checklist = [
    {
      title: 'Add Block & Customize Design',
      done: false,
      dialogueName: 'customizeDesign'
    },
    {
      title: 'Customize & Add Views',
      done: false,
      dialogueName: 'addViews'
    },
    {
      title: 'Preview Changes',
      done: false,
      dialogueName: 'previewChanges'
    },
    {
      title: 'Book a demo',
      done: false,
      dialogueName: 'bookDemo'
    },
    {
      title: 'Add Products (Connect Site)',
      done: false,
      dialogueName: 'addProduct'
    },
    {
      title: 'Generate App (Android & iOS)',
      done: false,
      dialogueName: 'generateApp'
    },
    {
      title: 'Send Push Notifications',
      done: false,
      dialogueName: 'sendPush'
    },
    {
      title: 'Upload App',
      done: false,
      dialogueName: 'uploadApp'
    }
  ]
  fileUploadProgress = 0
  pdfFileUploadProgress = 0
  sidebarOpened = true

  standalone = true;
  contentSettings: any;
  fincartActive: boolean = false
  fincartApiKey: string = ''
  constructor(
    private http: HttpClient,
    private helper: HelpersService,
    private viewsService: ViewsService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private pagesApi: PagesApiService,
    private projectApi: ProjectApiService,
    private settingsApi: SettingsApiService,
    private viewsApi: ViewsApiService,
    private storageApi: StorageApiService
  ) {

    super()
    this.token = this.getToken()
    this.builderUrl = this.helper.getBuilderUrl()
    const storedProject = localStorage.getItem('selectedProject')
    if (storedProject && storedProject !== 'null' && storedProject !== 'undefined') {
      this.selectedProject = storedProject
    }
    if (this.selectedProject && String(this.selectedProject) !== 'null' && String(this.selectedProject) !== 'undefined') {
      this.settingsApi.getSettingsByType(String(this.selectedProject), 'general_settings').then((settings) => {
        const val = settings?.['standalone']
        if (val !== undefined && typeof val !== 'object') {
          this.standalone = val
        } else if (val === undefined || typeof val === 'object') {
          // standalone not set yet — persist current default. Do NOT reload:
          // the fetch clients never throw (they return {} on failure), so a
          // failed read here would otherwise reload-loop the whole app.
          this.settingsApi.upsertSettingsByType(String(this.selectedProject), 'general_settings', { standalone: this.standalone })
            .catch(() => {})
        }
      })
    }
    this.loadProjectPlan();

  }

  getInitialTourStatus = () => {
    let postData = new URLSearchParams()
    // Make sure that the token is set correctly
    this.token = this.getToken()
    postData.set('token', this.token)
    return this.http.post(this.builderUrl + 'get-tour', postData.toString(), this.options)
  }
  /**
   * Get all projects from Backend
   */
  getProjects = (email: string): Observable<any> => {
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('email', email)
    // Make sure that the token is set correctly
    this.token = this.getToken()
    postData.set('token', this.token)

    return this.http.post(this.builderUrl + 'getProjects', postData.toString(), this.options)
  }
  /**
   * Get all type === purchase projects from Backend
   */
  getPurchaseProjects = (email: string): Observable<any> => {
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('email', email)
    this.token = this.getToken()
    postData.set('token', this.token)

    return this.http.post(this.builderUrl + 'get_purchase_projects', postData.toString(), this.options)
  }
  /**
   * Get all type !== purchase and status !=active and access != full projects from Backend
   */
  getNonePurchaseProjects = (email: string): Observable<any> => {
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('email', email)
    this.token = this.getToken()
    postData.set('token', this.token)

    return this.http.post(this.builderUrl + 'get_none_purchase_projects', postData.toString(), this.options)
  }

  /**
   * Get Certain Project id Data
   * @param id
   */
  getProject = (id: string) => {
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    this.token = this.getToken()
    postData.set('token', this.token)
    if (this.cacheProjectReq.data == postData.toString() && this.cacheProjectReq.response) {
      return of(this.cacheProjectReq.response)
    }
    this.cacheProjectReq = {
      data: postData.toString()
    }
    return this.http.post(this.builderUrl + 'getProject', postData.toString(), this.options)
  }

  /**
   * Update Project with Data
   */
  updateProject = (id: any, allBlocks: object, updateHome: boolean = false, view_id = 0, view_name = '') => {
    if (!localStorage.getItem('selectedView') || localStorage.getItem('selectedView') == 'null' || updateHome == true) {
      localStorage.setItem('selectedView', '{"view_id":1,"view_name":"home","title":"home"}')
    }
    let localSelectedView: any = localStorage.getItem('selectedView')
    localSelectedView = JSON.parse(localSelectedView)
    let tempBlocks = JSON.parse(JSON.stringify(allBlocks))
    let newBlocks = this.cleanUpProjectObj(tempBlocks)
    if (view_id == 0) {
      view_id = localSelectedView.view_id
      view_name = localSelectedView.view_name
    }

    if (this.standalone) {
      let data = {
        projectId: id,
        allBlocks: newBlocks,
        view_id: view_id,
        view_name: view_name
      }

      return new Observable<any>((observer) => {
        this.viewsApi.upsertProjectView(id, { view_id, view_name, all_blocks: newBlocks })
          .then(() => {
            observer.next()
            observer.complete()
          })
          .catch((error: any) => observer.error(error))
      })
    } else {
      let data = {
        process: 'sync_ui',
        projectId: id,
        allBlocks: newBlocks,
        token: this.getToken(),
        view_id: view_id,
        view_name: view_name
      }

      let optionsTemplate = {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
      }
      return this.http.post(this.builderUrl + 'updateProject', JSON.stringify(data), optionsTemplate)
    }
  }

  /**
   * This function is intended to cleanup the saved object before sending to database
   */
  cleanUpProjectObj = (tempBlocks: any) => {
    for (const key in tempBlocks) {
      if (Object.prototype.hasOwnProperty.call(tempBlocks, key)) {
        const element = tempBlocks[key]
        if (element.type == 'products') {
          delete element['productsData']
          delete element['categories']
        }
        tempBlocks[key] = element
      }
    }
    return tempBlocks
  }
  updateAllViews = async () => {
    for await (const element of this.viewsService.allViews) {
      if (element.view_id) {
        this.getView(element.view_id).subscribe(async (blocksData: any) => {
          this.updateProject(this.selectedProject, JSON.parse(blocksData), false, element.view_id, element.view_name).subscribe(async (result: any) => {})
        })
      }
    }
  }

  updateProjectWithNewViews = () => {
    if (this.standalone) {
      this.loadingTemplates = true
      // formats the allviews of wp to be standalone compatible
      let originalObject = this.viewsService.allViews
      const updatedObject = Object.keys(originalObject).reduce((acc: any, key) => {
        const viewIdValue = originalObject[key].view_id
        acc[viewIdValue] = originalObject[key]
        return acc
      }, {})
      this.viewsService.submitCustomerView(this.selectedProject, updatedObject).subscribe(() => {
        this.templateChoiceDone()
      })
    } else {
      // Delete old Views
      let postData = new URLSearchParams()
      this.loadingTemplates = true
      postData.set('process', 'sync_ui')
      postData.set('project_id', this.selectedProject)
      this.http.post(this.builderUrl + 'delete-all-views', postData.toString(), this.options).subscribe((response: any) => {
        this.submitViews(this.viewsService.allViews[0], this.viewsService.allViews.length, 0)
      })
    }
  }

  submitViews = (element: any, length: number, key: number) => {
    if (element.view_id) {
      let data = element.data ? element.data : element.allBlocks
      this.viewsService.submitView(element.view_name, this.selectedProject, element.view_id, data).subscribe((result: any) => {
        key = key + 1
        if (key < length) {
          this.submitViews(this.viewsService.allViews[key], length, key)
        } else {
          this.templateChoiceDone()
        }
      })
    }
  }

  templateChoiceDone = () => {
    this.showUpdateProgress = false
    this.customViews = []
    this.loadingTemplates = false
    this.sendSelectedView({ view_name: 'home', view_id: 1, title: 'home' })
    // disable the mobile view users from navigating to the builder and send them an email to use the app from the desktop
    // if (window.screen.width <= 768) { // 768px portrait
    //   // this.router.navigate(['/mobile-trials'], { relativeTo: this.route });
    // } else {
    if (this.getTour()) {
      window.location.href = '/products'
    } else {
      window.location.href = '/'
    }
    // disable the mobile view users from navigating to the builder and send them an email to use the app from the desktop
    // if (window.screen.width <= 768) { // 768px portrait
    //   // this.router.navigate(['/mobile-trials'], { relativeTo: this.route });
    //   window.location.href = '/';
    // } else {
    //   window.location.href = '/';
    // this.setTour(false).subscribe(() => {

    //   // // this.router.navigate(['/'], { relativeTo: this.route });
    //   // if you want to remove the window location refresh and go to the router navigate, uncomment the line above
    //   // and start handling getting the global_header and global_footer and save them in the database if not found, this is a replica from the app.component.ts
    //   // i deleted this code for now, refer to the history for backups
    // }, (err) => {

    // });
    // }
    // }
  }

  /**
   * Delete Project
   * @param id
   */
  deleteProject = (id: any) => {
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    this.token = this.getToken()
    postData.set('token', this.token)
    return this.http.post(this.builderUrl + 'deleteProject', postData.toString(), this.options)
  }

  /**
   * Delete Project Images from WordPress uploads
   * Deletes all files in wp-content/uploads/project_assets/images/{projectId}
   * @param id Project ID
   */
  deleteProjectImages = (id: any) => {
    let postData = new URLSearchParams()
    postData.set('projectId', id)
    this.token = this.getToken()
    postData.set('token', this.token)
    return this.http.post(this.builderUrl + 'deleteProjectImages', postData.toString(), this.options)
  }

  /**
   * Activate Project
   * @param id
   */
  activateProject = (id: any) => {
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    this.token = this.getToken()
    postData.set('token', this.token)
    return this.http.post(this.builderUrl + 'activateProject', postData.toString(), this.options)
  }

  /**
   * Tour Setter and Getter
   */
  setTour = (tourStatus: boolean) => {
    this.tourStart = tourStatus
    localStorage.setItem('tourStart', this.tourStart)
    let postData = new URLSearchParams()
    this.token = this.getToken()
    postData.set('token', this.token)
    if (tourStatus) {
      postData.set('tourStart', 'true')
    } else {
      postData.set('tourStart', 'false')
    }
    return this.http.post(this.builderUrl + 'set-tour', postData.toString(), this.options)
  }

  getTour = () => {
    // Tour guide is disabled - always return false
    return false
    // Original logic (kept for reference):
    // this.tourStart = localStorage.getItem('tourStart') == 'false' ? false : true
    // return this.tourStart
  }

  public uploadFileCustomerServer(file: File, id: any, type: string): Observable<any> {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('file', file)
    formData.append('token', this.token)
    formData.append('projectId', id)
    formData.append('file_type', type)
    let project_domain = this.selectedProjectDomain
    if (!project_domain) {
      project_domain = 'https://demo.stacksclients.com'
    }
    let customerURL = project_domain + '/wp-json/avaris-wc-rest/v3/'
    return this.http.post(customerURL + 'receive_builder_image', formData)
  }

  /**
   * Token Getter, Gets the Token from the Localstorage to maintain modularity of the function
   */
  /** One project_metadata value by key, or null when unset. */
  getProjectMetadataValue = (projectId: string, key: string): Observable<string | null> => {
    return from(this.projectApi.getProjectMetadataValue(projectId, key))
  }

  getToken = () => {
    return localStorage.getItem('token')
  }

  /**
   * Project Getter
   */

  getSelectedProject = () => {
    return Number(localStorage.getItem('selectedProject'))
  }

  /**
   * retrieve the limit of the number of projects that we can create
   */
  getProjectsLimit = () => {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('token', this.token)
    return this.http.post(this.builderUrl + 'getLimit', formData)
  }

  /**
   * Add New Project Request
   */
  createProject = () => {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('token', this.token)
    formData.append('projectId', String(localStorage.getItem('selectedProject')))
    return this.http.post(this.builderUrl + 'createProject', formData)
  }

  /**
   * Add New Project Request
   */
  createFreeProject = (email: string, coupon_description: string = '', self_ltd = false, password = '') => {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('token', this.token)
    formData.append('email', email);
    formData.append('password', password);
    // formData.append('website_url', "https://demo.stacksclients.com");
    formData.append('website_url', '')
    if (coupon_description) {
      formData.append('coupon', coupon_description)
      formData.append('type', 'ltd')
    }

    if (self_ltd) {
      formData.append('type', 'self_ltd')
    }

    return this.http.post(this.builderUrl + 'create_free_project', formData)
  }

  convertToManualPaymentProject = (email: string, project_id: any, paypal = false, paypal_sub_id = '', pricing_id = '') => {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('token', this.token)
    formData.append('email', email)
    formData.append('project_id', project_id)
    if (paypal) {
      formData.append('paypal', 'true')
      formData.append('paypal_sub_id', paypal_sub_id)
      formData.append('pricing_id', pricing_id)
    }

    return this.http.post(this.builderUrl + 'manual_payment', formData)
  }

  /**
   * Get Project Config, woocommerce active or not
   */
  getProjectConfig = () => {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('token', this.token)
    formData.append('projectId', String(localStorage.getItem('selectedProject')))
    return this.http.post(this.builderUrl + 'getProjectConfig', formData)
  }

  logData = (message: string, event_name: string, event_action: string) => {
    const formData = new FormData()
    this.token = this.getToken()
    let documentCookie = document.cookie?.match(/_ga=(.+?);/)
    formData.append('token', this.token)
    formData.append('project_id', String(localStorage.getItem('selectedProject')))
    formData.append('message', message)
    formData.append('event_name', event_name)
    formData.append('event_action', event_action)
    formData.append('path', 'App Builder')
    formData.append('ids', 'all')
    if (documentCookie) {
      let gaUserId = documentCookie[1].split('.').slice(-2).join('.')
      formData.append('cid', gaUserId)
    }

    return this.http.post(this.builderUrl + 'stacks-log', formData)
  }

  getView = (view_id: any = 0, view_name = '') => {
    if (this.standalone) {
      let project_id = String(this.selectedProject)
      return new Observable<any>((observer) => {
        // this.db.getDatabase('projects/' + project_id + '/views/' + view_id).subscribe(...)  // Firebase
        from(this.viewsApi.getProjectViews(project_id)).subscribe((allViews: any) => {
          const view = allViews[String(view_id)] ?? null
          observer.next(view)
          observer.complete()
        })
      })
    } else {
      const formData = new FormData()
      this.token = this.getToken()
      formData.append('token', this.token)
      formData.append('projectId', String(localStorage.getItem('selectedProject')))
      if (view_name) {
        formData.append('view_name', view_name)
      } else {
        formData.append('view_id', view_id)
      }
      return this.http.post(this.builderUrl + 'getProjectView', formData)
    }
  }

  defaultViewsChecker = () => {
    const formData = new FormData()
    this.token = this.getToken()
    let data = {
      token: this.token,
      projectId: String(localStorage.getItem('selectedProject')),
      categoryView: this.categoryView,
      singleCategoryView: this.singleCategoryView,
      singleView: this.singleView,
      loginView: this.loginView,
      signupView: this.signupView,
      forgotView: this.forgotView,
      myAccountView: this.myAccountView,
      singleBlogPostView: this.singleBlogPostView,
      cartView: this.cartView,
      checkoutView: this.checkoutView,
      aboutView: this.aboutView,
      contactView: this.contactView,
      termsView: this.termsView,
      searchView: this.searchView,
      wishlistView: this.wishlistView,
      referralView: this.referralView
    }
    let optionsTemplate = {
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    }
    return this.http.post(this.builderUrl + 'defaultViewsChecker', JSON.stringify(data), optionsTemplate)
  }
  /**
   * Login to stacks sites
   */
  loginDemoSite = () => {
    const formData = new FormData()
    this.token = this.getToken()
    formData.append('token', this.token)
    formData.append('projectId', String(localStorage.getItem('selectedProject')))
    return this.http.post(this.builderUrl + 'loginDemoSite', formData)
  }

  /**
   * Get all views and save in customViews Variable
   */
  getViews = () => {
    this.showUpdateProgress = true
    this.viewsService.getViews(this.selectedProject).subscribe((response: any) => {
      this.customViews = []
      this.showUpdateProgress = false
      for (const key in response.data) {
        if (Object.prototype.hasOwnProperty.call(response.data, key)) {
          let count = Number(key)
          const element = response.data[count]
          let data = element.data ? JSON.parse(element.data) : element.data
          this.customViews.push({ view_id: element.view_id, view_name: element.view_name, data: data })
        }
      }
    })

    this.viewsService.getViews(this.selectedProject, 'get_all_views').subscribe((response: any) => {
      this.allViews = []
      this.showUpdateProgress = false
      for (const key in response.data) {
        if (Object.prototype.hasOwnProperty.call(response.data, key)) {
          let count = Number(key)
          const element = response.data[count]
          let data = element.data ? JSON.parse(element.data) : element.data
          this.allViews.push({ view_id: element.view_id, view_name: element.view_name, data: data })
        }
      }
    })
  }

  /**
   * Get all website pages and save in websitePages Variable
   */
  getPages = () => {
    // this.db.getDatabase('projects/' + this.selectedProject + '/pages/').subscribe(...)  // Firebase
    from(this.pagesApi.getProjectPages(this.selectedProject)).subscribe((response: any) => {
      this.websitePages = []
      for (const key in response) {
        if (Object.prototype.hasOwnProperty.call(response, key)) {
          const element = response[key]
          this.websitePages.push({
            page_id: element.page_id || key,
            page_name: element.page_name,
            title: element.title || element.page_name
          })
        }
      }
    })
  }

  /**
   * Gets the premium package details
   */
  getPackage = () => {
    let postData = new URLSearchParams()
    let project_id: any = this.getSelectedProject()

    postData.set('project_id', project_id)

    return this.http.post(this.builderUrl + 'get_package', postData.toString(), this.options)
  }

  uploadImage(selectedFile: any, id: any, folder: string, randomizeName: boolean = true) {
    const originalFileName = selectedFile.name
    const randomString = this.helper.generateRandomString(10)
    const newFileName = randomizeName ? randomString + originalFileName : originalFileName
    selectedFile = new File([selectedFile], newFileName, { type: selectedFile.type })

    return new Observable<any>((observer) => {
      this.optimizeFileSize(selectedFile).subscribe(
        (optimizedFile: any) => {
          this.storageApi.upload(optimizedFile, id, `images/${folder}/${optimizedFile.name}`)
            .then((publicUrl) => {
              this.fileUploadProgress = 100
              observer.next(publicUrl)
              observer.complete()
            })
            .catch((err) => observer.error(err))
        },
        (err: any) => observer.error(err)
      )
    })
  }
    /**
   * Uploads a PDF or document file to Firebase Storage under a specific project ID.
   *
   * @param selectedFile - The file to be uploaded
   * @param id - The project ID to group files under
   * @param randomizeName - Whether to prefix the filename with a random string (default: true)
   * @returns An Observable that emits the download URL once upload is complete
   */
  uploadPdf(selectedFile: File, id: any, randomizeName: boolean = true, progressCallback?: (progress: number) => void) {
    const originalFileName = selectedFile.name
    const randomString = this.helper.generateRandomString(10)
    const newFileName = randomizeName ? `${randomString}_${originalFileName}` : originalFileName
    selectedFile = new File([selectedFile], newFileName, { type: selectedFile.type })

    return new Observable<string>((observer) => {
      progressCallback?.(10)
      this.storageApi.upload(selectedFile, id, `documents/${selectedFile.name}`)
        .then((publicUrl) => {
          progressCallback?.(100)
          observer.next(publicUrl)
          observer.complete()
        })
        .catch((err) => observer.error(err))
    })
  }

  /**
   * Deletes a file from Firebase Storage using its public download URL.
   *
   * @param fileURL - The full download URL of the file to delete
   * @returns An Observable that emits when deletion is complete or errors if not
   */
  deleteDocument = (fileURL: string): Observable<any> => {
    return new Observable((observer) => {
      if (!fileURL) {
        observer.error('Invalid file URL')
        return
      }
      this.storageApi.deleteFile(this.selectedProject, fileURL)
        .then(() => {
          observer.next('Document deleted')
          observer.complete()
        })
        .catch((err) => observer.error(err))
    })
  }

  /**
   * Optimize image sizes before uploading to the server to maintain space and speed
   * @param selectedFile
   */
  optimizeFileSize = (selectedFile: any) => {
    var options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1024,
      useWebWorker: true
    }
    return new Observable<any>((observer) => {
      if (selectedFile.type == 'image/gif') {
        observer.next(selectedFile) // Notify the observer that the operation is complete
        observer.complete()
        return
      }
      imageCompression(selectedFile, options)
        .then(function (compressedFile) {
          observer.next(compressedFile) // Notify the observer that the operation is complete
          observer.complete() // Complete the Observable// write your own logic
        })
        .catch(function (error) {
          observer.error(error.message) // Notify the observer that the operation is complete
          observer.complete() // Complete the Observable// write your own logic
        })
    })
  }

  deleteImage = (fileURL: string) => {
    return new Observable<any>((observer) => {
      const projectId = this.helper.extractProjectIdFromUrl(fileURL)
      if (projectId !== String(this.selectedProject)) {
        observer.next('image belongs to selected project and was not deleted')
        observer.complete()
        return
      }
      for (const protectedUrl of this.protectedImages) {
        if (fileURL.includes(protectedUrl)) {
          observer.next('image is protected and was not deleted')
          observer.complete()
          return
        }
      }
      this.storageApi.deleteFile(this.selectedProject, fileURL)
        .then(() => {
          observer.next('image deleted')
          observer.complete()
        })
        .catch((err) => observer.error(err))
    })
  }

  getCustomViews = () => {
    if (this.headerBtn === 'websitePageEditor') {
      return this.websitePages
    }
    return this.customViews.filter((view: any) => {
      if (view.view_name == 'global_header' || view.view_name == 'global_footer') {
        return false
      } else {
        return true
      }
    })
  }

  importDummyProducts = () => {
    return new Observable<any>((observer) => {
      observer.next()
      observer.complete()
    })
  }

  importDummyCategories = () => {
    return new Observable<any>((observer) => {
      observer.next()
      observer.complete()
    })
  }


  cookieSetter = (name: string, value: any, days: any) => {
    var expires = ''
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + value + expires + '; path=/' // Set path to root '/'
  }

  cookieGetter = (name: string) => {
    var nameEQ = name + '='
    var cookies = document.cookie.split(';')
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i]
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length)
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length)
      }
    }
    return null
  }

    /**
   * Checks whether the user accessed the app through "Genie" mode.
   * This function reads the `source` value stored in `localStorage`
   * and returns `true` if the value equals `'genie'`, otherwise `false`.
   * @returns {boolean} True if the user is in Genie mode, false otherwise.
   */
  isFromGenie(): boolean {
    return localStorage.getItem('source') === 'genie';
  }

  /**
   * Sets the Genie mode flag.
   * @param value Whether to enable Genie mode.
   */
  setGenieMode(value: boolean, params: any): void {
    if (value) {
      localStorage.setItem('source', 'genie');
      // it should be data, design or settings
      localStorage.setItem('genieMode', params['genieMode']);      
    } else {
      localStorage.removeItem('source');
      localStorage.removeItem('genieMode');
    }
  }

  getGenieMode() {
    return localStorage.getItem('genieMode')
  }
  
  /**
   * Load the project's effective plan (legacy project or account subscription) and set is_premium
   */
  loadProjectPlan(): Promise<void> {
    const projectId = String(this.selectedProject);
    return this.projectApi.getProjectSubscription(projectId).then((sub: { package: string; unlimitedSources: string[] } | null) => {
      this.is_premium = (sub?.package || 'free').toLowerCase() !== 'free';
    }).catch((err: unknown) => {
      console.error('Failed to load project plan type:', err);
      this.is_premium = false;
    });
  }

  
  navigateBack() {
    this.location.back()
  }
}
